module.exports = __webpack_public_path__ + "static/media/nologo.c0c008e2.png";